module.exports = __webpack_public_path__ + "static/media/killer_wall.9c4267f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/books/originals/killer_wall.jpg
// module id = 112
// module chunks = 0